import { type FC } from "react";

type Props = {
  label: string;
  onClick?: () => void;
};

const QuizOption: FC<Props> = ({ label, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className="inline-flex items-center justify-center whitespace-nowrap rounded-[100px] border border-[#1f2022] bg-transparent px-8 py-[15px] font-ppMori text-[14px] leading-[20px] text-[#1f2022] transition-colors hover:bg-[#1f2022] hover:text-white md:text-[16px] md:leading-[22px] 2xl:text-[18px] 2xl:leading-[26px]"
  >
    {label}
  </button>
);

export default QuizOption;
